import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MediaFile } from 'elements-sdk'

@Component({
  selector: 'directory-icon',
  templateUrl: './directoryIcon.component.pug',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-role': 'img',
  },
})
export class DirectoryIconComponent {
  @Input() directory: MediaFile

  getClass () {
    return {
      'text-info': !this.directory.isShowroom,
      'text-rare': this.directory.isShowroom,
      'text-muted': this.directory.isExcluded,
      fas: !!this.directory.childCount,
      fal: !this.directory.childCount,
    }
  }
}
